export default {
  2011: {
    items: [
      "Afghanistan",
      "Albania",
      "Algeria",
      "Angola",
      "Argentina",
      "Armenia",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Brazil",
      "Brunei Darussalam",
      "Bulgaria",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Chile",
      "China (excludes SARs and Taiwan)",
      "Colombia",
      "Congo, Democratic Republic of",
      "Cook Islands",
      "Costa Rica",
      "Cote d'Ivoire",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Czechia",
      "Denmark",
      "Djibouti",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "England",
      "Eritrea",
      "Estonia",
      "Eswatini",
      "Ethiopia",
      "Fiji",
      "Finland",
      "France",
      "French Polynesia",
      "Gaza Strip and West Bank",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guyana",
      "Honduras",
      "Hong Kong (SAR of China)",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland (Northern)",
      "Ireland (Republic of)",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Korea, Republic of (South)",
      "Kosovo",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Lithuania",
      "Luxembourg",
      "Macau (SAR of China)",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Malta",
      "Mauritius",
      "Mexico",
      "Moldova",
      "Mongolia",
      "Montenegro",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Nigeria",
      "Niue",
      "North Macedonia",
      "Norway",
      "Oman",
      "Pakistan",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russian Federation",
      "Rwanda",
      "Samoa",
      "Saudi Arabia",
      "Scotland",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tanzania",
      "Thailand",
      "Timor-Leste",
      "Togo",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United States of America",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela",
      "Vietnam",
      "Wales",
      "Yemen",
      "Zambia",
      "Zimbabwe",
      "Antarctica",
      "Australia (includes External Territories)",
      "Caribbean",
      "Central America",
      "Central and West Africa",
      "Central Asia",
      "Chinese Asia (includes Mongolia)",
      "Eastern Europe",
      "Japan and the Koreas",
      "Mainland South-East Asia",
      "Maritime South-East Asia",
      "Melanesia",
      "Micronesia",
      "Middle East",
      "North Africa",
      "Northern America",
      "Northern Europe",
      "Polynesia (excludes Hawaii)",
      "South America",
      "South Eastern Europe",
      "Southern and East Africa",
      "Southern Asia",
      "Southern Europe",
      "United Kingdom, Channel Islands and Isle of Man",
      "Western Europe"
    ]
  },
  2016: {
    items: [
      "Afghanistan",
      "Albania",
      "Algeria",
      "Angola",
      "Argentina",
      "Armenia",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Brazil",
      "Brunei Darussalam",
      "Bulgaria",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Chile",
      "China (excludes SARs and Taiwan)",
      "Colombia",
      "Congo, Democratic Republic of",
      "Cook Islands",
      "Costa Rica",
      "Cote d'Ivoire",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Czechia",
      "Denmark",
      "Djibouti",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "England",
      "Eritrea",
      "Estonia",
      "Eswatini",
      "Ethiopia",
      "Fiji",
      "Finland",
      "France",
      "French Polynesia",
      "Gaza Strip and West Bank",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guyana",
      "Honduras",
      "Hong Kong (SAR of China)",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland (Northern)",
      "Ireland (Republic of)",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Korea, Republic of (South)",
      "Kosovo",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Lithuania",
      "Luxembourg",
      "Macau (SAR of China)",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Malta",
      "Mauritius",
      "Mexico",
      "Moldova",
      "Mongolia",
      "Montenegro",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Nigeria",
      "Niue",
      "North Macedonia",
      "Norway",
      "Oman",
      "Pakistan",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russian Federation",
      "Rwanda",
      "Samoa",
      "Saudi Arabia",
      "Scotland",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tanzania",
      "Thailand",
      "Timor-Leste",
      "Togo",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United States of America",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela",
      "Vietnam",
      "Wales",
      "Yemen",
      "Zambia",
      "Zimbabwe",
      "Antarctica",
      "Australia (includes External Territories)",
      "Caribbean",
      "Central America",
      "Central and West Africa",
      "Central Asia",
      "Chinese Asia (includes Mongolia)",
      "Eastern Europe",
      "Japan and the Koreas",
      "Mainland South-East Asia",
      "Maritime South-East Asia",
      "Melanesia",
      "Micronesia",
      "Middle East",
      "North Africa",
      "Northern America",
      "Northern Europe",
      "Polynesia (excludes Hawaii)",
      "South America",
      "South Eastern Europe",
      "Southern and East Africa",
      "Southern Asia",
      "Southern Europe",
      "United Kingdom, Channel Islands and Isle of Man",
      "Western Europe"
    ]
  },
  2021: {
    items: [
      "Afghanistan",
      "Albania",
      "Algeria",
      "Angola",
      "Argentina",
      "Armenia",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Brazil",
      "Brunei Darussalam",
      "Bulgaria",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Chile",
      "China (excludes SARs and Taiwan)",
      "Colombia",
      "Congo, Democratic Republic of",
      "Cook Islands",
      "Costa Rica",
      "Cote d'Ivoire",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Czechia",
      "Denmark",
      "Djibouti",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "England",
      "Eritrea",
      "Estonia",
      "Eswatini",
      "Ethiopia",
      "Fiji",
      "Finland",
      "France",
      "French Polynesia",
      "Gaza Strip and West Bank",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guyana",
      "Honduras",
      "Hong Kong (SAR of China)",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland (Northern)",
      "Ireland (Republic of)",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Korea, Republic of (South)",
      "Kosovo",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Lithuania",
      "Luxembourg",
      "Macau (SAR of China)",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Malta",
      "Mauritius",
      "Mexico",
      "Moldova",
      "Mongolia",
      "Montenegro",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Nigeria",
      "Niue",
      "North Macedonia",
      "Norway",
      "Oman",
      "Pakistan",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russian Federation",
      "Rwanda",
      "Samoa",
      "Saudi Arabia",
      "Scotland",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tanzania",
      "Thailand",
      "Timor-Leste",
      "Togo",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United States of America",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela",
      "Vietnam",
      "Wales",
      "Yemen",
      "Zambia",
      "Zimbabwe",
      "Antarctica",
      "Australia (includes External Territories)",
      "Caribbean",
      "Central America",
      "Central and West Africa",
      "Central Asia",
      "Chinese Asia (includes Mongolia)",
      "Eastern Europe",
      "Japan and the Koreas",
      "Mainland South-East Asia",
      "Maritime South-East Asia",
      "Melanesia",
      "Micronesia",
      "Middle East",
      "North Africa",
      "Northern America",
      "Northern Europe",
      "Polynesia (excludes Hawaii)",
      "South America",
      "South Eastern Europe",
      "Southern and East Africa",
      "Southern Asia",
      "Southern Europe",
      "United Kingdom, Channel Islands and Isle of Man",
      "Western Europe"
    ]
  }
};



// WEBPACK FOOTER //
// ../data/wa/birthplace.js